import React, { useState } from "react";
import { Toolbar, Button, styled } from "@mui/material";
import { Link } from "react-router";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useNavigate } from "react-router";

const StyledToolbar = styled(Toolbar)`
  width: 100%;
  background-color: white;
  border-top: 2px solid ${(props) => props.theme.palette.primary.main};
  display: flex;
  justify-content: space-between;
`;

const StyledLink = styled(Link)`
  text-decoration: none;
`;
const Divider = styled("div")`
  width: 10px;
  height: auto;
  display: inline-block;
`;

interface Props {
  backUrl: string;
  nextUrl: string;
  disableNext?: boolean;
  disableBack?: boolean;
  nextLabel?: string;
  backLabel?: string;
  nextFunction?: any;
  backFunction?: any;
}

const BottomNav = (props: Props): any => {
  const {
    backUrl,
    nextUrl,
    disableNext,
    disableBack,
    backLabel,
    nextLabel,
    nextFunction,
    backFunction,
  } = props;

  const bulkEditActive = window.location.pathname.startsWith("/bulk_edit/");

  const [discardModalOpen, setDiscardModalOpen] = useState(false);

  const disableLinkEvent = (e: any) => {
    e.preventDefault();
  };

  const BulkEditDiscardModal = () => {
    const navigate = useNavigate();
    const discard = () => {
      sessionStorage.removeItem("bulkEditActive");
      sessionStorage.removeItem("bulkEditList");
      navigate("/review");
    };

    return (
      <Dialog
        open={discardModalOpen}
        onClose={() => setDiscardModalOpen(false)}
      >
        <DialogTitle>Discard Bulk Edit?</DialogTitle>
        <DialogContent>
          <>
            <p>
              You&apos;ll lose all changes and we can&apos;t recover them once
              you discard it
            </p>
            <p>Are you sure you want to discard bulk edit?</p>
          </>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setDiscardModalOpen(false)}
            variant="outlined"
            data-test-id="cancel-button"
          >
            Cancel
          </Button>

          <Button onClick={discard} color="error" data-test-id="discard-button">
            Discard
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  return (
    <>
      <BulkEditDiscardModal />

      <StyledToolbar>
        {bulkEditActive && (
          <Button
            onClick={() => {
              setDiscardModalOpen(true);
            }}
            variant="outlined"
            color="primary"
            data-test-id="btn-discard-bulk-edit"
          >
            Discard Bulk Edit
          </Button>
        )}
        <div
          style={{ display: "flex", flexDirection: "row", marginLeft: "auto" }}
        >
          {backFunction ? (
            <Button
              onClick={backFunction}
              variant="outlined"
              color="primary"
              disabled={disableBack}
              data-test-id="btn-back"
            >
              {backLabel || "Back"}
            </Button>
          ) : (
            <StyledLink
              onClick={(e: any) => {
                if (disableBack) disableLinkEvent(e);
              }}
              to={backUrl}
            >
              <Button
                variant="outlined"
                disabled={disableBack}
                data-test-id="btn-back"
              >
                {backLabel || "Back"}
              </Button>
            </StyledLink>
          )}
          <Divider />
          {nextFunction ? (
            <Button
              onClick={nextFunction}
              variant="contained"
              color="primary"
              disabled={disableNext}
              data-test-id="btn-next"
            >
              {nextLabel || "Continue"}
            </Button>
          ) : (
            <StyledLink
              onClick={(e: any) => {
                if (disableNext) disableLinkEvent(e);
              }}
              to={nextUrl}
            >
              <Button
                variant="contained"
                disabled={disableNext}
                data-test-id="btn-next"
              >
                {nextLabel || "Continue"}
              </Button>
            </StyledLink>
          )}
        </div>
      </StyledToolbar>
    </>
  );
};

export default BottomNav;
